<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 70%;">
                <div class="modal-header">
                    <h3 class="form-header">Sliding Scale Administration</h3>
                    <button @click="closeModal()" class="red-close-button">
                        <i class="pi pi-times" style="padding: 0"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal">
                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                                <div class="form-section-container" style="grid-template-columns: 3fr 4fr 4fr; grid-gap: 24px; width: 100%; padding: 0 25px;">

                                <div class="left-form-section-panel" style="padding: 0;" v-if="!selectedDrug.sliding_scale.length">
                                    <div class="icon-container">
                                        <div class="icon-circle">
                                            <img class="icon-circle-item" src="../../assets/icons/medIconWhite.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="left-form-section-panel" style="padding: 0;" v-else>
                                    <h4 style="text-align: left; margin: 0; margin-bottom: 10px;">
                                        Sliding Scale
                                    </h4>
                                    <div
                                        v-for="(item, index) in selectedDrug.sliding_scale"
                                        :key="index"
                                        style="display: flex; padding: 5px; align-items: center; width: 10em; justify-content: space-between"
                                    >
                                        <p style="font-size: 1em; width: 5em; text-align: right">
                                            {{item.min}} {{item.max ? '-' : '+'}} {{item.max}}: 
                                        </p>
                                        <!-- :style="selectedIndex == index ? {backgroundColor: '#00AD50', color: 'white'}:{}" -->
                                        <p style="font-size: 1em; font-weight: bold; margin-left: 20px; background-color: #f3f4f4; border-radius: 4px; padding: 5px 10px; width: 50px;">
                                            {{item.value}}
                                        </p>
                                    </div>
                                    <div class="small-input" style="margin: 10x; margin-left: 0px; margin-bottom: 15px; width: fit-content">
                                        <p style="text-align: left; margin: 0; font-size: 1em; margin-top: 10px; margin-bottom: 5px;">
                                            Enter {{readingUnitLabel}} Reading:
                                        </p>
                                        <InputNumber
                                            :minFractionDigits="0"
                                            :maxFractionDigits="2"
                                            v-tooltip.right="'Reading'"
                                            mode="decimal"
                                            style="border: 1px solid grey; border-radius: 4px; width: 5em;"
                                            v-model="enteredReading"
                                            @focus="$event.target.select()"
                                        />
                                    </div>
                                    <div v-if="dangerWarningMessage" style="width: 20em; margin-bottom: 15px; padding: 10px; background-color: #fdecea; border: 1px solid #E04F39; border-radius: 4px;">
                                        <p style="margin: 0; color: #E04F39; font-weight: bold; font-size: 0.9em; text-align: left;">
                                            <i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>{{ dangerWarningMessage }}
                                        </p>
                                        <div style="display: flex; align-items: center; margin-top: 8px;">
                                            <Checkbox v-model="acknowledgeDangerReading" :binary="true" inputId="ackDangerReading" />
                                            <label for="ackDangerReading" style="margin-left: 8px; font-size: 0.85em; text-align: left;">I acknowledge this warning</label>
                                        </div>
                                    </div>
                                    <div class="blue-button" @click="addReading()" :style="(dangerWarningMessage && !acknowledgeDangerReading) ? {backgroundColor: 'grey', cursor: 'not-allowed'} : {}">
                                        Submit Readings
                                    </div>
                                </div>
                                <div class="left-form-section-panel" style="padding: 0;">
                                    <div class="grey-container">
                                        <p>
                                            <b>Route: </b>{{selectedDrug.route}}
                                        </p>
                                        <p>
                                            {{selectedDrug.instructions.split('-------Please write any additional notes below this line-------').join('')}}
                                        </p>
                                        <p>
                                            <b>Indication:</b> {{selectedDrug.indication ? selectedDrug.indication : 'Not provided.'}}
                                        </p>
                                        <p v-if="isOver24hMaxDose" style="color: #E04F39; font-weight: bold;">
                                            <b>Max dose 24hrs:</b> <span v-if="selectedDrug.max_dose">{{selectedDrug.max_dose}} {{selectedDrug.dose_unit}}{{selectedDrug.max_dose > 1 ? 's':''}}</span> <span v-else>Not provided.</span>
                                        </p>
                                        <p v-else>
                                            <b>Max dose 24hrs:</b> <span v-if="selectedDrug.max_dose">{{selectedDrug.max_dose}} {{selectedDrug.dose_unit}}{{selectedDrug.max_dose > 1 ? 's':''}}</span> <span v-else>Not provided.</span>
                                        </p>
                                        <p>
                                            <b>Last Event:</b> <span v-if="selectedDrug.last_chart_administrations.length">{{selectedDrug.last_chart_administrations[0]?.administered_at}}</span>
                                            <span v-else>Never administered.</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="right-form-section-panel" style="padding: 0;">
                                    <div>
                                        <h3 class="form-header">{{selectedDrug.alias.name}}</h3>
                                        <div style="margin: 10x; margin-left: 0px; margin-bottom: 15px; ">
                                            <div v-if="selectedDrug.stock_items?.length && selectedDrug.stock_items[0]?.name">
                                                <!-- IF SINGLE ITEM -->
                                                <p style="font-size: 1em; text-align: left" v-if="selectedDrug.stock_items.length == 1"><b>Dispensed drug:</b> {{selectedDrug.stock_items[0].alias.name}}</p>
                                                <!-- IF MULTIPLE ITEMS -->
                                                <div v-else style="display: grid; grid-gap: 5px; align-items: start;">
                                                    <p style="font-size: 1em; text-align: left; margin-bottom: 0;"><b>Confirm dispensed drug: </b></p>
                                                    <Dropdown v-model="selected_stock_item" :options="selectedDrug.stock_items" optionLabel="name"
                                                    
                                                    :placeholder="selected_stock_item ? selected_stock_item.alias.name : 'Select drug'" />
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <p style="text-align: left; margin: 0; margin-top: 20px">
                                                Enter Quantity ({{selectedDrug.dose_unit}}{{selectedDrug.dose > 1 ? 's':''}}) - {{ doseContainerQty }} {{ selectedDrug.container_unit }}{{doseContainerQty > 1 ? 's':''}}
                                                </p>
                                                <InputNumber
                                                    :minFractionDigits="0"
                                                    :maxFractionDigits="2"
                                                    v-tooltip.right="'Prescription Quantity'"
                                                    mode="decimal"
                                                    style="border: 1px solid grey; border-radius: 4px; "
                                                    v-model="enteredDose"
                                                    @focus="$event.target.select()"
                                                    
                                                /> 
                                            </div>
                                                       
                                        </div>
                                        <div v-if="selectedDrug.sliding_scale.length">
                                            <p style="font-size: 1em; text-align: left">
                                                Last reading: <b>{{ lastReading ? lastReading.value : 'No reading taken' }}</b>
                                            </p>
                                            <p style="font-size: 1em; text-align: left">
                                                Time of last reading: {{ lastReading ? lastReading.takenAt : 'N/A' }}<template v-if="lastReadingTakenForHumans"> ({{ lastReadingTakenForHumans }})</template>
                                            </p>
                                        </div>
                                    </div>
                                    <!-- <div style="background-color: rgb(229, 241, 254);border-radius: 6px;">
                                        <p class="note-header" style="margin: 0; padding-bottom: 5px;">
                                            Notes
                                        </p>
                                        <textarea
                                            class="noresize"
                                            name="notes"
                                            id="note-modal"
                                            rows="11"
                                            placeholder="Enter notes here..."
                                            style="width: 100%;border-radius: 6px; border-top-right-radius: 0px; border-top-left-radius: 0px; border: none; background-color: #E5F1FE; padding: 0 8px;"
                                            v-model="notes">
                                        </textarea>
                                    </div> -->
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <SingleVerify
                            @click="()=>{removeDrugFromRegister(selectedDrug)}"
                            v-if="selectedDrug?.stock_items?.length && !selectedDrug.removed"
                            :isPRN="false"
                            @getDrugId="getDrugId"
                            :payload="removeFromRegisterPayload" 
                            endpoint="/drug-safe-retrieval"
                            :drugSafeRemoval="true"
                            :dual="true"
                            :id="selectedDrug?.uuid"
                            :textRemoveButton="true"
                            :notes="notes"
                            :discardAvailable="discardAvailable"
                            :stock_items="selectedDrug?.stock_items"
                        />
                        <button v-else class="green-button" @click="signAction()" :disabled="isOverMaxDoseLimit || (dangerWarningMessage && !acknowledgeDangerReading)" :style="(isOverMaxDoseLimit || (dangerWarningMessage && !acknowledgeDangerReading)) ? 'background-color: grey !important;' : ''">
                           Sign
                        </button>
                        <!-- ">{{selectedDrug.last_chart_administrations[selectedDrug.last_chart_administrations.length-1].administered_at -->
                            <!-- selectedDrug.last_chart_administrations.slice(-1).administered_at ?   enteredDose > selectedDrug.max_dose -->
                            <!-- 2 conditions. 1. if dose entered+all doses in the last 24hr exceed max 24hour dose 2. if enetered dose is greater than max administration dose -->
                        <p v-if="isOverMaxDoseLimit" style="color: #E04F39; font-weight: bold; margin-left: 5px;">
                           Entered dose will exceed max dose limit
                        </p>
                        
                    </slot>
                </div>
            </div>
        </div>
        <!-- Require Dual Signature for any S8 PRN meds -->
        <SignatureModal
            v-if="displaySignatureModal"
            @isSuccessful="isSuccessful"
            :payload="payload"
            @close="closeSignatureModal"
            :dual="requiresDoubleSig || enteredReading"
            :endpoint="signature_endpoint"
            @getDrugId="getDrugId"
            :noAuthRequired="noAuthRequired"
            :loop="loop"
            :displayReason="true"
        />
        <SuccessModal
            v-if="displaySuccessModal"
            :first_spec_line="displayMessage"
            @close="closeSuccessModal"
        />
    </div>
</template>

<script>
import SignatureModal from './SignatureModal.vue';
import SingleVerify from '@/components/verification/SingleVerify.vue';
import SuccessModal from './SuccessModal.vue';
import axios from 'axios';
import { isProxy, toRaw } from 'vue';
import { tagsRequireDoubleSig, tagsInclude } from '@/services/doubleSignature';
import { isWarfarinOrInrChart, getSafeRangeFromSlidingScale, isReadingOutsideRange, selectSlidingScaleBandIndex, readingIdentityForChart } from '@/services/slidingScale';
import { diffForHumans } from '@/services/dates';


export default {
    props: [
        'message',
        'close',
        'loading',
        'statusMessage',
        'action',
        'actionType',
        'noAuthRequired',
        'adminSubmission',
        'loop',
        'selectedDrug',
        'patientId',
        'readings',
        'latestInrReading',
        ''
    ],
    components: {
        SignatureModal,
        SingleVerify,
        SuccessModal
    },
    data() {
        return {
            selected_stock_item: null,
            displaySuccessModal: false,
            displayMessage:'',
            payload:'',
            discardAmount:0,
            discardAvailable:false,
            // enteredDose: this.selectedPRN && this.selectedPRN.sliding_scale && !this.selectedPRN.sliding_scale.length ? parseFloat(this.selectedPRN.dose) : 0,
            enteredDose: 0,
            // doseContainerQty:0,
            enteredReading:0,
            acknowledgeDangerReading: false,
            savedReading: null,
            selectedIndex: 0,
            signature_endpoint:'/administer',
            displaySignatureModal: false,
            removeFromRegisterPayload: [],
            removedFromRegister: false,
            drug_safe_retrieval:'',
            selectedCode:'',
            notes:'',
            doseOmittedCode:[
            {value:  'A',
              label:'Absent'
            },
            {value:  'F',
              label:'Fasting'
            },
            {value:  'H',
              label:'Hospital'
            },
            {value:  'L',
              label:'On Leave'
            },
            {value:  'S',
              label:'Sleeping'
            },
              {value:'S/A',
                  label:'Self Administration'
                },
            {value:  'V',
              label:'Vomiting'
            },
              {value:'A/T',
                  label:'Adjusted Administration'
                },
            {value:  'C',
              label:'Contraindicated'
            },
            {value:  'N',
              label:'Not available'
            },
              {value:'N/R',
                  label:'Not Required'
                },
            {value:  'O',
              label:'Omitted'
            },
            {value:  'R',
              label:'Refused'
            },
            {value:  'W',
              label:'Withheld (clinical)'
            },
              {value:'W/R',
                  label:'Withheld (pending results)'
                },
            ]
        }
    },
    methods: {
        recommendedSlidingDose() {
            // `savedReading` is checked first because this is re-run straight after addReading() -
            // for an INR chart the `latestInrReading` prop is still the pre-existing reading at
            // that point (the parent only pushes new readings into `patient.readings`, it doesn't
            // refresh `patient.latest_inr_reading`), so without this the recommendation would be
            // recalculated from the superseded reading.
            let lastReading = null;
            if (this.savedReading) {
                lastReading = this.savedReading.value;
            } else if (this.isWarfarinOrINR && this.latestInrReading) {
                lastReading = this.latestInrReading.value;
            } else if (this.readings && this.readings.length) {
                lastReading = this.readings[0].value;
            }

            if (lastReading === null) return;
            // Band selection is numeric and lives in slidingScale.js - see the comment there for
            // why comparing these values as-is picks the wrong dose band.
            const index = selectSlidingScaleBandIndex(this.selectedDrug?.sliding_scale, lastReading);
            if (index !== null) {
                this.selectedIndex = index;
            }
        },
        addReading() {
            // Guard against an empty reading - the InputNumber sets the model to null
            // when cleared, and enteredReading.toString() below would throw.
            if (this.enteredReading === null || this.enteredReading === undefined || this.enteredReading === '') {
                this.displayMessage = 'Please enter a reading before submitting.';
                this.displaySuccessModal = true;
                return;
            }
            // CLINICAL DANGER THRESHOLD CHECK: blocks submission of a dangerously elevated/flagged
            // reading until the user has explicitly acknowledged the warning shown in the UI.
            if (this.dangerWarningMessage && !this.acknowledgeDangerReading) {
                this.displayMessage = `${this.dangerWarningMessage} Please acknowledge the warning above before submitting.`;
                this.displaySuccessModal = true;
                return;
            }

            this.$store.dispatch('getRefreshToken');
            this.displaySuccessModal = true;
            const reading = readingIdentityForChart(this.selectedDrug);
            this.displayMessage = `Updating ${reading.unit} reading.`;
            let payload = {
                patient_id:this.patientId,
                unit: reading.unit,
                type: reading.type,
                // Sent (and kept) as a number. Stringifying it here was what made the downstream
                // sliding scale band comparison lexicographic, because this value is echoed back
                // into `patient.readings` by the parent and then re-read by recommendedSlidingDose().
                value: this.enteredReading
            }
            console.log('this is the payload for reading', payload);
            axios.post('/create-reading', payload, this.$store.state.header)
            .then(res => {
                console.log(res);
                delete payload.patient_id;
                this.displayMessage = 'Successfully updated reading.';
                res.data.value = this.enteredReading;
                console.log('emitting this create reading res', res.data);
                this.savedReading = {
                    value: this.enteredReading,
                    date: res.data.created_at,
                    id: res.data.uuid
                };
                this.$emit('addInsulinReading', res.data);
                this.acknowledgeDangerReading = false;
                setTimeout(() => {
                    this.displaySuccessModal = false;
                    this.recommendedSlidingDose();
                }, 1000)
            }).catch(err => {
                this.displayMessage = err.response.data
            })
        },
        closeSuccessModal(value) {
            if (value) {
                this.displaySuccessModal = false;
            }
        },
        removeDrugFromRegister(drug) {
            let discard_amount = parseFloat(Math.ceil(this.doseContainerQty) - this.doseContainerQty).toFixed(2);
            let qty = parseFloat(this.doseContainerQty).toFixed(2);
                
            if(discard_amount > 0){
                console.log("discard amount is greater than 0: " + discard_amount);
            }else{
                console.log("discard amount is not greater than 0: " + discard_amount);
            }

            this.removeFromRegisterPayload = 
                {
                    prescriber_uuid:drug.prescriber_id,
                    stock_item_id: this.selected_stock_item.uuid,
                    quantity: qty.toString(),
                    patient_id: this.patientId,
                    dose_quantity: this.enteredDose,
                    dose_unit: drug.dose_unit,
                    ...((discard_amount > 0) && { discard_amount: discard_amount.toString() }), // conditionally adds discard_amount to payload
                }
                
            this.discardAvailable = discard_amount > 0 ? discard_amount + " " + drug.container_unit + "/s" : false;
        },
        getDrugId(value) {
            console.log('HIT THE DRUG SAFE RETRIEVAL ID IN SINGLEVERIFY', value);
            this.$store.dispatch('getRefreshToken');
            this.$emit('updateDrug', value);
            this.removedFromRegister = true;
            this.drug_safe_retrieval = value.drug_safe_retrieval;
        },
        cancelAction() {
            this.$emit('stopAction', true);
            this.$emit('close', true);
        },
        isSuccessful(value) {
            if (value) {
                console.log('this is the value from administering general sliding scale chart', value);
                this.displaySignatureModal = false;
                this.$emit('successfullySubmitted', true);
                this.$emit('completeSlidingScaleActivity', {administered_at: value.administered_at, id: this.selectedDrug.uuid, response: value});
                this.closeModal();
            }
        },
        signAction() {
            // Mirrors the guard in addReading() — a nurse can type a dangerous/out-of-range reading
            // and click Sign directly without ever pressing "Submit Reading", which would otherwise
            // bypass the warning entirely.
            if (this.dangerWarningMessage && !this.acknowledgeDangerReading) {
                return;
            }
            this.displaySignatureModal = true;
            let date = new Date();
            // not technically this.adminSubmission.calendar_item_id but is being passed via prop as such, it is indeed the chart_id;
            let notes = `Dose administered.

Date: ${date.toLocaleDateString('en-AU')}
Time of administration: ${date.toLocaleTimeString('en-AU')}
Drug name: ${this.selectedDrug.alias.name}
Dose: ${this.enteredDose} ${this.selectedDrug.dose_unit}/s ${(this.selectedDrug.container_unit.toLowerCase() === 'ampoule' && this.selectedDrug.container_unit.toLowerCase() !== this.selectedDrug.dose_unit.toLowerCase()) ? '[' + this.doseContainerQty + ' Ampoule(s)' + ']': ''}
Administration Route: ${this.selectedDrug.route}
${this.enteredReading ? 'Reading : '+this.enteredReading : ''}
`
            this.payload = {
                calendar_item_id:this.adminSubmission.calendar_item_id,
                doc:'',
                notes:notes,
                dose: this.enteredDose.toString(),
                drug_safe_retrieval: this.drug_safe_retrieval ? this.drug_safe_retrieval : this.adminSubmission.drug_safe_retrieval,
                reading: this.savedReading ? this.savedReading.id : (this.isWarfarinOrINR && this.latestInrReading) ? this.latestInrReading.uuid : this.readings && this.readings.length ? this.readings[0].uuid :''
            }
            console.log('SIGN ACTION CONDITION', this.payload);
            console.log('SIGN ACTION HITTING ELSE THEN ELSE CONDITION');
            
            console.log('this is the payload', this.payload);
        },
        closeSignatureModal(value) {
            if (value) {
                this.displaySignatureModal = false;
            }
        },
        closeModal() {
            console.log('hitting this closemodal function');
            if (this.reloadPageOnClose == true) {
                this.$emit('close', 'reload');

            } else {
                this.$emit('close', true);

            }
        },
    },
    watch: {
        enteredReading() {
            this.acknowledgeDangerReading = false;
        }
    },
    // watch:{
    //     enteredDose(newValue){
    //         let containerConstant = this.selectedPRN?.container_constant ?? 1
    //         let myQty = parseFloat(newValue / containerConstant);

    //         this.doseContainerQty = myQty.toFixed(2);

    //         this.discardAmount = parseFloat(Math.ceil(myQty) - myQty);
            
            
    //     }
    // },
    computed: {
        // The reading shown as "last reading" and used for the recommended dose band, resolved in
        // one place instead of the same three-way precedence being spelled out per template line.
        // `savedReading` is the one just entered in this modal; `latestInrReading` is preferred
        // over readings[0] on a warfarin/INR chart because readings[0] can be a BGL.
        lastReading() {
            if (this.savedReading) {
                return { value: this.savedReading.value, takenAt: this.savedReading.date };
            }
            if (this.isWarfarinOrINR && this.latestInrReading) {
                return { value: this.latestInrReading.value, takenAt: this.latestInrReading.created_at };
            }
            if (this.readings && this.readings.length) {
                return { value: this.readings[0].value, takenAt: this.readings[0].created_at };
            }
            return null;
        },
        // How long ago that reading was taken, in words. kraken's latest-reading relations carry no
        // date bound, so the reading driving the recommended dose can be arbitrarily old and the
        // absolute timestamp alone left the nurse to work out how old. Null when unreadable, in
        // which case the template shows the absolute timestamp on its own.
        lastReadingTakenForHumans() {
            return this.lastReading ? diffForHumans(this.lastReading.takenAt) : null;
        },
        // S8/S4 (and any facility-nominated double signature drug tag) requires a witness.
        // Insulin is a separate, independent dual-signature trigger.
        requiresDoubleSig() {
            const facility = this.$store.getters.getCurrentLocation?.facility;
            const tags = this.selectedDrug?.alias?.tags || [];
            return tagsRequireDoubleSig(tags, facility) || tagsInclude(tags, 'insulin');
        },
        isWarfarinOrINR() {
            // NOTE: only `name` (and `min`/`max`/`value`) survive the round trip through the backend's
            // SlidingScaleResource — `reading_type`/`reading_unit` are never persisted or returned, so they
            // can't be relied on here even though they're set client-side at prescription creation time.
            return isWarfarinOrInrChart(this.selectedDrug);
        },
        // Label the input with the unit the reading will actually be stored as, so the prompt can't
        // drift from what addReading() persists.
        readingUnitLabel() {
            return readingIdentityForChart(this.selectedDrug).unit;
        },
        // The safe range a reading is checked against is entirely defined by the prescriber's
        // sliding scale bands (Min/Max) - there is no separate hardcoded clinical threshold.
        inrRange() {
            return getSafeRangeFromSlidingScale(this.selectedDrug.sliding_scale);
        },
        inrRangeMin() {
            return this.inrRange.min;
        },
        inrRangeMax() {
            return this.inrRange.max;
        },
        isOutsideInrRange() {
            if (!this.isWarfarinOrINR) return false;
            return isReadingOutsideRange(this.enteredReading, this.inrRange);
        },
        dangerWarningMessage() {
            if (this.isOutsideInrRange) {
                return `WARNING: Latest INR (${this.enteredReading}) is outside the prescribed safe range (${this.inrRangeMin ?? '–'}–${this.inrRangeMax ?? '–'}). Please verify before administering and notify the prescriber if required.`;
            }
            return '';
        },
        // Refused/omitted/withheld events (doc set) don't count toward the daily dose total - only
        // actual administrations do.
        // The backend type is Vec<Option<ChartAdministration>> - a null element is possible, and
        // `.filter(Boolean)` drops it before `!admin.doc` is evaluated, since `null.doc` would throw
        // and break this computed (which feeds signDisabled/dangerWarningMessage, so a single null
        // entry would otherwise break the entire admin modal render rather than just the dose tally).
        dailydose() {
            let amount_administered = 0
            const actualAdministrations = (this.selectedDrug.last_chart_administrations || [])
                .filter(Boolean)
                .filter(admin => !admin.doc);
            actualAdministrations.forEach(admin => {
                amount_administered += parseFloat(admin.quantity);
            })
            return amount_administered
        },
        isOver24hMaxDose() {
            if (this.selectedDrug?.chart_type !== 'PRN' && !this.selectedDrug?.max_dose) {
                return false;
            }
            return (this.dailydose + this.enteredDose) > this.selectedDrug?.max_dose;
        },
        isOverMaxAdminDose() {
            if (this.selectedDrug?.chart_type !== 'PRN' && !this.selectedDrug?.max_admin_dose) {
                return false;
            }
            return this.enteredDose > this.selectedDrug?.max_admin_dose;
        },
        isOverMaxDoseLimit() {
            return this.isOver24hMaxDose || this.isOverMaxAdminDose;
        },
        doseContainerQty(){

            let containerConstant = this.selectedDrug?.container_constant ?? 1
            let myQty = parseFloat(this.enteredDose / containerConstant);

            //this.doseContainerQty = myQty.toFixed(2);

            //this.discardAmount = parseFloat(Math.ceil(myQty) - myQty);

            return myQty.toFixed(2);
        }

    },
    mounted() {
        if (!this.adminSubmission.length) {
            console.log('HITTING THE IF ON MOUNT')
            this.payload = {...this.adminSubmission};
        } else {
            console.log('HITTING THE ELSE ON MOUNT')
            this.payload = this.adminSubmission;
        }
        if(this.selectedDrug.stock_items && this.selectedDrug.stock_items.length){
            
            this.selectedDrug.stock_items.forEach(item=>{
                console.log('got stock items', this.selectedDrug.stock_items)
                item.name = item.alias.name;
            })
            
            
            this.selected_stock_item = this.selectedDrug.stock_items[0];
        }
        this.recommendedSlidingDose()
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

.icon-container {
    width: 282px;
    height: 240px;
    left: 25px;
    background: #94D6D0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-circle {
    border-radius: 50%;
    height: 131px;
    width: 131px;
    background: #00B2A2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.small-input {
    span {
        width: 50%;
        input {
            width:50%;
        }
    }
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.icon-circle-item {
    width: 75px;
}

.doc-grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 10px;
}

.grey-container {
    background-color: #f3f4f4;
    height: 100%;
    border-radius: 6px;
    padding: 20px;
    text-align: left;
    p {
        margin-bottom: 10px !important;
        font-size: 15px;
    }
}

.doc-item {
    padding: 3px;
    background-color: white;
    color: $error;
    border-radius: 6px;
    border: 2px solid $error;
    cursor: pointer;
    width: 186px;
    height: 50px;
    font-size: 15px;
    font-weight: bold;
}

.selected-doc-item {
    background-color: $error;
    color: white;
}

 

 

  

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}
</style>
